import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import { Box, LinearProgress, SelectChangeEvent } from '@mui/material'
import styled from '@emotion/styled'
import SingleSelect from '../../../../components/muiComponents/singleSelect'
import { H3 } from '../../../../layouts/TextStyles'
import { topicApiSlice } from '../../../../features/topic/topicSlice'
import { videonotesApiSlice } from '../../../../features/section/videonotesSlice'
import { VideoNotesAnalysisState } from '../../../../features/types'
import { VIDEO } from '../../../../utils/constants'
import TopicProgressCard from '../components/TopicProgressCard'

interface Props {
    subjectId: number | null
    studentId: number
    userCourseEnrollId: number
    loadingSubjects?: boolean
    monthNumber?: number
    weekNumber?: number
}

const VideoTab: React.FC<Props> = ({
    subjectId,
    studentId,
    userCourseEnrollId,
    loadingSubjects = false,
    monthNumber,
    weekNumber,
}) => {
    const [searchParams] = useSearchParams()
    const [courseSubject, setCourseSubject] = useState(Number(searchParams.get('courseSubjectId')) || null)
    const { data: topics = [], isFetching } =
        topicApiSlice.useGetStudentTopicVideoAnalysisQuery(
            { courseSubjectId: courseSubject, studentId, monthNumber, weekNumber },
            { skip: !courseSubject },
        )

    // Конспекты студента по предмету: раскладываем по videoLessonId, чтобы
    // показать статус конспекта прямо под каждым видеоуроком
    const { data: notes = [] } =
        videonotesApiSlice.useGetStudentTopicVideonotesAnalysisQuery(
            { courseSubjectId: courseSubject, userCourseEnrollId },
            { skip: !courseSubject },
        )

    // Ключуем и по id, и по названию урока: id приходит после обновления бэкенда,
    // до него связываем по videoLessonTitle
    const conspectByVideo = React.useMemo(() => {
        const map = new Map<string, VideoNotesAnalysisState>()
        notes.forEach((note) => {
            if (note.videoLessonId) map.set(`id:${note.videoLessonId}`, note)
            if (note.videoLessonTitle) map.set(`t:${note.videoLessonTitle}`, note)
        })
        return map
    }, [notes])

    useEffect(() => {
        if (subjectId) {
            setCourseSubject(subjectId)
        }
    }, [subjectId])

    return (
        <Box>
            {isFetching ? (
                <LinearProgress />
            ) : (
                topics.map((topic) => (
                    <TopicProgressCard
                        key={topic.courseTopicId}
                        topic={topic}
                        studentId={studentId}
                        type={VIDEO}
                        conspectByVideo={conspectByVideo}
                    />
                ))
            )}
        </Box>
    )
}

export default VideoTab

